"use client"
import React from 'react'
import {useTekstClient} from "hooks/useTekstClient";
import Switch from "react-switch";
import {MdViewDay, MdViewHeadline} from "react-icons/md";
import { useSearchParams } from 'next/navigation'
import {useSetSearchParams} from "hooks/useSetSearchParams";

export const KennisCentrumHeader = ({total, question}) => {
    const {resetParams} = useSetSearchParams()
    const {tekst} = useTekstClient()

    return <div className="flex flex-wrap gap-x-3 gap-y-1 items-center">

        {/*BreadCrumbs*/}
        <div>
            <div onClick={resetParams} className={`font-bold cursor-pointer underline hover:text-kleur-cyan whitespace-nowrap`}>{tekst('pagina:support:kenniscentrum:titel')}</div>
        </div>

        {/*Search label + question*/}
        {question && <div className="flex items-center gap-1 whitespace-nowrap">
            <small className="text-kleur-grijs-blauw2">{tekst('pagina:support:kenniscentrum:filters:filtersactief:zoekterm')}:</small>
            <small className="font-semibold">{question}</small>
        </div>}

        {/*Aantal*/}
        <div>
            {total !== null && <small className="whitespace-nowrap"><b>{total}</b> {tekst('pagina:support:kenniscentrum:resultaten')}</small>}
        </div>

    </div>
}

export const KennisCentrumToggle = () => {
    const {updateParam} = useSetSearchParams()
    const searchParams = useSearchParams()
    const isWeergaveCompact = searchParams.get('cpt') === "1"
    const {tekst} = useTekstClient()

    return (
        <label title={tekst('pagina:support:kenniscentrum:weergave')}>
            <Switch
                checked={isWeergaveCompact}
                checkedIcon={false}
                uncheckedIcon={false}
                checkedHandleIcon={
                    <div className="flex h-full w-full items-center justify-center text-[11px] text-darkGrey2">
                        <MdViewHeadline/>
                    </div>
                }
                uncheckedHandleIcon={
                    <div className="flex h-full w-full items-center justify-center text-[11px] text-darkGrey2">
                        <MdViewDay/>
                    </div>
                }
                onChange={() => {
                    updateParam('cpt', isWeergaveCompact ? null : 1 )
                }}
                height={18}
                width={40}
                offColor={'#23c1f4'}
                onColor={'#23c1f4'}
            />
        </label>
    )
}